export default __webpack_public_path__ + "8bffb50ed000e9dfa2c069c0368bbf59.jpg";